// extracted by mini-css-extract-plugin
export var aboveInput = "_mn-0";
export var actionButton = "_mn-5";
export var actionButtonContainer = "_mn-1";
export var actionIcon = "_mn-6";
export var aiInfoContainer = "_mn-2";
export var attachmentWrapper = "_mn-7";
export var bold = "_mn-3";
export var checkIcon = "_mn-8";
export var clickingRecipientBar = "_mn-11";
export var commentThreadSwitch = "_mn-a";
export var draftImage = "_mn-b";
export var draftImageContainer = "_mn-c";
export var draftImages = "_mn-e";
export var editButton = "_mn-g";
export var editor = "_mn-f";
export var editorContainer = "_mn-y";
export var editorErrorTooltipWrapper = "_mn-9";
export var headerDivider = "_mn-h";
export var icon = "_mn-i";
export var info = "_mn-j";
export var internal = "_mn-n";
export var internalDivider = "_mn-k";
export var internalMessage = "_mn-l";
export var messageInputCard = "_mn-m";
export var messageInputForm = "_mn-o";
export var messageInputFormInternal = "_mn-p";
export var options = "_mn-q";
export var publicMessageCustomer = "_mn-s";
export var publicMessageMerchant = "_mn-r";
export var removeImageButton = "_mn-d";
export var replyButtons = "_mn-t";
export var showSignatureButton = "_mn-u";
export var spinner = "_mn-v";
export var verticalButtonDivider = "_mn-4";
export var visibilitySelector = "_mn-w";
export var warning = "_mn-x";
export var wrappingText = "_mn-z";
export var writingInternalNoteTopBorder = "_mn-10";